import {
    RosterProfileQuery,
    RosterProfileQueryVariables,
    RosterType,
} from '__generated__/graphql'
import { FC, useState } from 'react'
import DrawerComponent from 'shared/components/DrawerComponent'
import { ApolloQueryRefetchFunction } from 'shared/types/graphql'
import { CandidateFilterStateWithMetadata } from 'shared/utils/mappingFilterConverter'
import AddOrEdit from './AddOrEdit'
import AddToExisting from './AddToExisting'

export type RosterDrawerTypes = 'existing' | 'new' | 'edit'

export interface RosterDrawerProps {
    type?: RosterDrawerTypes
    onClose: () => void
    selectedCandidates: string[]
    mappingFilter?: CandidateFilterStateWithMetadata
    presetRosterType?: RosterType
    rosterId?: string
    refetch?: ApolloQueryRefetchFunction<
        RosterProfileQuery,
        RosterProfileQueryVariables
    >
}

const drawerTitles = {
    existing: 'Add to Existing',
    new: 'Create New',
    edit: 'Edit',
}

const RosterDrawer: FC<RosterDrawerProps> = ({
    type,
    selectedCandidates = [],
    mappingFilter,
    onClose,
    presetRosterType,
    rosterId,
    refetch,
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const getFormByType = () => {
        switch (type) {
            case 'existing':
                return (
                    <AddToExisting
                        selectedCandidates={selectedCandidates}
                        setIsLoading={(newVal) => setIsLoading(newVal)}
                        onClose={onClose}
                        rosterId={rosterId}
                    />
                )
            // add and edit roster have the same form just call a different mutation + either start empty or start prefilled
            case 'new':
            case 'edit':
                return (
                    <AddOrEdit
                        edit={type === 'edit'}
                        setIsLoading={(newVal) => setIsLoading(newVal)}
                        mappingFilter={mappingFilter}
                        selectedCandidates={selectedCandidates}
                        onClose={onClose}
                        rosterId={rosterId}
                        refetch={refetch}
                        presetRosterType={presetRosterType}
                    />
                )
            default:
                return <></>
        }
    }

    const closeDrawer = () => {
        if (isLoading) return
        onClose()
    }

    const title =
        type &&
        `${drawerTitles[type]} ${!!presetRosterType ? presetRosterType : 'Search'}`

    return (
        <DrawerComponent
            open={!!type}
            onClose={closeDrawer}
            headerTitle={title || ''}
            hasSaveButton={false}
            width="min(40vw, 35rem)"
        >
            {getFormByType()}
        </DrawerComponent>
    )
}

export default RosterDrawer
